import { useCallback, useEffect } from 'react';
import { useRouteError } from 'react-router-dom';

import { ERROR_CODE } from '@packages/constants';

import { ErrorScreen } from '@components/errorScreen';
import { useErrorText } from '@hooks';
import { navigateToFirstRegionView } from '@routes/router';
import { captureException } from '@sentry/react';

export const DefaultFallback = () => {
  const error = useRouteError();

  useEffect(() => {
    if (error instanceof Error) {
      captureException(error, { tags: { source: 'errorBoundary' } });
    }
  }, [error]);

  const handleGoHomepage = useCallback(() => {
    window.location.replace('/');
  }, []);

  const { getErrorScreenProps } = useErrorText({
    quoteId: '123',
    onGetNewQuote: navigateToFirstRegionView,
    onGoHomepage: handleGoHomepage,
  });

  return (
    <ErrorScreen
      {...getErrorScreenProps({ name: ERROR_CODE.INTERNAL_ERROR } as unknown as Error)}
    />
  );
};
